export const M1_UNIT_6 = {
  id: "u6-possessive-apostrophe",
  title: "Unit 6: The Apostrophe 'S",
  topic: "Possession: Tom's car & Parents' house",
  iconType: "quote",
  grammarImage: "/u6-apostrophe.jpg",
  grammarText:
    "Use 's for one owner (Tom's car). Use s' for plural owners ending in s (my parents' house). Irregular plurals keep 's (children's toys). Shared: Tom and Mary's car (one car). Separate: Tom's and Mary's cars (two cars).",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: SINGULAR POSSESSION ('s)
    // ----------------------------------------------------------------------
    {
      id: "u6-set1",
      title: "Set 1: Singular 'S",
      questions: [
        {
          type: "match",
          q: "Match the owner to the correct phrase.",
          pairs: [
            { left: "Tom", right: "Tom's car" },
            { left: "Anna", right: "Anna's house" },
            { left: "The dog", right: "The dog's ball" }
          ],
          a: "completed"
        },
        { type: "mc", q: "The car of John = ___ car.", options: ["John's", "Johns", "Johns'"], a: "John's" },
        { type: "mc", q: "The room of the boy = The ___ room.", options: ["boy's", "boys'", "boys"], a: "boy's" },

        { type: "input", q: "This is ___ phone. (Sarah)", a: "Sarah's" },
        { type: "input", q: "Is this ___ bag? (David)", a: "David's" },

        { type: "order", q: "Order the words.", words: ["This", "is", "Tom's", "dog."], a: "This is Tom's dog." },

        {
          type: "match",
          q: "Match the person to something they own.",
          pairs: [
            { left: "Mom", right: "Mom's book" },
            { left: "Dad", right: "Dad's car" },
            { left: "My sister", right: "My sister's room" }
          ],
          a: "completed"
        },

        {
          type: "mc",
          q: "Choose the correct sentence.",
          options: ["The cat's name is Fluffy", "The cats name is Fluffy"],
          a: "The cat's name is Fluffy"
        },

        { type: "input", q: "Where is ___ coat? (Lisa)", a: "Lisa's" },
        { type: "order", q: "Order the words.", words: ["It", "is", "Anna's", "pen."], a: "It is Anna's pen." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: PLURAL POSSESSION (s')
    // ----------------------------------------------------------------------
    {
      id: "u6-set2",
      title: "Set 2: Plural S'",
      questions: [
        {
          type: "match",
          q: "Match the phrase to the meaning.",
          pairs: [
            { left: "Student's book", right: "One student" },
            { left: "Students' books", right: "Many students" },
            { left: "Teacher's pen", right: "One teacher" }
          ],
          a: "completed"
        },

        { type: "mc", q: "The house of my parents = My ___ house.", options: ["parents'", "parent's", "parents's"], a: "parents'" },
        { type: "mc", q: "The toys of the boys = The ___ toys.", options: ["boys'", "boy's", "boys"], a: "boys'" },

        { type: "input", q: "The girls share a room. It is the ___ room. (girls)", a: "girls'" },

        { type: "order", q: "Order the words.", words: ["These", "are", "the", "students'", "books."], a: "These are the students' books." },

        {
          type: "match",
          q: "Match the plural owner to the thing (idea check).",
          pairs: [
            { left: "Dogs'", right: "bones" },
            { left: "Cats'", right: "milk" },
            { left: "Birds'", right: "nest" }
          ],
          a: "completed"
        },

        { type: "mc", q: "Many teachers share one room. It is the ___ room.", options: ["teachers'", "teacher's", "teachers"], a: "teachers'" },

        { type: "input", q: "My sisters share a car. It is my ___ car. (sisters)", a: "sisters'" },

        { type: "order", q: "Order the words.", words: ["This", "is", "my", "parents'", "house."], a: "This is my parents' house." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: IRREGULAR PLURALS ('s)
    // ----------------------------------------------------------------------
    {
      id: "u6-set3",
      title: "Set 3: Children's & Men's",
      questions: [
        {
          type: "match",
          q: "Match the irregular plural to the possessive form.",
          pairs: [
            { left: "Children", right: "Children's toys" },
            { left: "Men", right: "Men's shoes" },
            { left: "Women", right: "Women's clothes" }
          ],
          a: "completed"
        },

        { type: "mc", q: "A park for children = a ___ park.", options: ["children's", "childrens'", "childs'"], a: "children's" },
        { type: "mc", q: "A store for men = a ___ store.", options: ["men's", "mens'", "mans"], a: "men's" },

        { type: "input", q: "The women have a team. It is the ___ team. (women)", a: "women's" },

        { type: "order", q: "Order the words.", words: ["Where", "is", "the", "men's", "room?"], a: "Where is the men's room?" },

        {
          type: "match",
          q: "Match singular vs irregular plural possessive.",
          pairs: [
            { left: "Man's", right: "Men's" },
            { left: "Child's", right: "Children's" },
            { left: "Woman's", right: "Women's" }
          ],
          a: "completed"
        },

        { type: "mc", q: "These are the ___ cars. (people)", options: ["people's", "peoples'", "persons"], a: "people's" },

        { type: "input", q: "This is the ___ school. (children)", a: "children's" },

        { type: "order", q: "Order the words.", words: ["The", "women's", "team", "won."], a: "The women's team won." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: SHARED POSSESSION (Tom and Mary's)
    // ----------------------------------------------------------------------
    {
      id: "u6-set4",
      title: "Set 4: Two Owners",
      questions: [
        {
          type: "match",
          q: "Match the two owners to the shared thing (one item).",
          pairs: [
            { left: "Tom and Mary", right: "Tom and Mary's car" },
            { left: "Ben and Jerry", right: "Ben and Jerry's apartment" },
            { left: "Mom and Dad", right: "Mom and Dad's room" }
          ],
          a: "completed"
        },

        {
          type: "mc",
          q: "The dog belongs to Joe and Greg (one dog). It is ___ dog.",
          options: ["Joe and Greg's", "Joe's and Greg's", "Joe and Gregs'"],
          a: "Joe and Greg's"
        },

        { type: "input", q: "This is ___ house. (Sam and Lisa)", a: "Sam and Lisa's" },

        { type: "order", q: "Order the words.", words: ["It", "is", "Pete", "and", "Aziz's", "snake."], a: "It is Pete and Aziz's snake." },

        {
          type: "match",
          q: "Shared vs separate (meaning check).",
          pairs: [
            { left: "One shared car", right: "Tom and Mary's car" },
            { left: "Two different cars", right: "Tom's and Mary's cars" },
            { left: "One shared house", right: "Mom and Dad's house" }
          ],
          a: "completed"
        },

        { type: "mc", q: "A party for Kim and Ken (one party) = ___ party.", options: ["Kim and Ken's", "Kim's and Ken's"], a: "Kim and Ken's" },

        { type: "input", q: "We are at ___ party right now. (Ben and Anna)", a: "Ben and Anna's" },

        { type: "order", q: "Order the words.", words: ["This", "is", "Sue", "and", "Dan's", "baby."], a: "This is Sue and Dan's baby." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: FAMILY TREES (Logic)
    // ----------------------------------------------------------------------
    {
      id: "u6-set5",
      title: "Set 5: Family Logic",
      questions: [
        {
          type: "match",
          q: "Match the relationship phrase to the family word.",
          pairs: [
            { left: "My father's brother", right: "Uncle" },
            { left: "My mother's sister", right: "Aunt" },
            { left: "My uncle's son", right: "Cousin" }
          ],
          a: "completed"
        },

        { type: "mc", q: "My mother's father is my ___.", options: ["Grandfather", "Uncle", "Father"], a: "Grandfather" },
        { type: "mc", q: "My sister's husband is my ___.", options: ["Brother-in-law", "Cousin", "Uncle"], a: "Brother-in-law" },

        { type: "input", q: "My brother's daughter is my ___.", a: "niece" },

        { type: "order", q: "Order the words.", words: ["She", "is", "my", "uncle's", "wife."], a: "She is my uncle's wife." },

        {
          type: "match",
          q: "Match the in-law relationship.",
          pairs: [
            { left: "Wife's mother", right: "Mother-in-law" },
            { left: "Husband's father", right: "Father-in-law" },
            { left: "Son's wife", right: "Daughter-in-law" }
          ],
          a: "completed"
        },

        { type: "mc", q: "My father's wife (not my mom) is my ___.", options: ["Stepmother", "Aunt", "Sister"], a: "Stepmother" },

        { type: "input", q: "My aunt's husband is my ___.", a: "uncle" },

        { type: "order", q: "Order the words.", words: ["He", "is", "my", "cousin's", "dad."], a: "He is my cousin's dad." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: STORY PART 1 (Reading)
    // ----------------------------------------------------------------------
    {
      id: "u6-set6",
      title: "Set 6: Story - A New Friend",
      questions: [
        {
  type: "mc",
  q: `READING:
Sara is 10. Sara's parents are Mark and Ana.

Question: Who is Ana?`,
  options: ["Sara's mother", "Sara's sister", "Sara's aunt"],
  a: "Sara's mother"
},
{
  type: "blank",
  q: `READING:
Sara has a brother named Leo. Leo's favorite toy is a small robot.

Question: The robot is ___ (Leo) toy.`,
  a: "Leo's"
},

        {
          type: "match",
          q: "Match the people to their roles.",
          pairs: [
            { left: "Mark", right: "Sara's father" },
            { left: "Ana", right: "Sara's mother" },
            { left: "Leo", right: "Sara's brother" }
          ],
          a: "completed"
        },
        { type: "input", q: "Ana is ___ wife. (Mark)", a: "Mark's" },
        { type: "order", q: "Order the words.", words: ["Leo", "is", "Sara's", "brother."], a: "Leo is Sara's brother." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: STORY PART 2 - PETS (Reading)
    // ----------------------------------------------------------------------
    {
      id: "u6-set7",
      title: "Set 7: Story - The Pets",
      questions: [
        {
  type: "mc",
  q: `READING:
The family has a dog. The family's dog is named Bouncer.

Question: Choose the correct phrase.`,
  options: ["family's dog", "family dog's", "families dog"],
  a: "family's dog"
},
{
  type: "blank",
  q: `READING:
Leo has a snake. Leo's snake is green.

Question: The snake is ___ snake.`,
  a: "Leo's"
},

        {
          type: "match",
          q: "Match the pet to the owner.",
          pairs: [
            { left: "Bouncer", right: "The family's dog" },
            { left: "The snake", right: "Leo's pet" },
            { left: "No pet", right: "Sara" }
          ],
          a: "completed"
        },
        { type: "input", q: "The ___ name is Hiss. (snake)", a: "snake's" },
        { type: "order", q: "Order the words.", words: ["Bouncer", "is", "the", "family's", "dog."], a: "Bouncer is the family's dog." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: STORY PART 3 - GRANDPARENTS' VISIT (Reading)
    // ----------------------------------------------------------------------
    {
      id: "u6-set8",
      title: "Set 8: Story - The Visit",
      questions: [
        {
  type: "mc",
  q: `READING:
On Sundays, they visit the grandparents' house.

Question: Choose the correct option.`,
  options: ["The grandparents' house", "The grandparent's house", "The grandparent house"],
  a: "The grandparents' house"
},
{
  type: "blank",
  q: `READING:
Grandpa shows Leo some old coins.

Question: The coins belong to ___.`,
  a: "Grandpa",
  alts: ["Grandpa Alf"]
},

        {
          type: "match",
          q: "Match the person to the action.",
          pairs: [
            { left: "Grandma", right: "Cooks lunch" },
            { left: "Grandpa", right: "Shows coins" },
            { left: "The family", right: "Visits on Sunday" }
          ],
          a: "completed"
        },
        { type: "input", q: "They go to their ___ house. (parents)", a: "parents'" },
        { type: "order", q: "Order the words.", words: ["They", "visit", "the", "grandparents'", "house."], a: "They visit the grandparents' house." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: MIXED PRACTICE (Dialogue)
    // ----------------------------------------------------------------------
    {
      id: "u6-set9",
      title: "Set 9: Dialogue",
      questions: [
        { type: "order", q: "Order the question.", words: ["Is", "this", "your", "brother's", "car?"], a: "Is this your brother's car?" },

        { type: "mc", q: "No, it is my ___ car. (one sister)", options: ["sister's", "sisters", "sisters'"], a: "sister's" },

        // Chris: aceptar Chris's y Chris' (según estilo)
        { type: "input", q: "Whose bag is this? It is ___ bag. (Chris)", a: "Chris's", alts: ["Chris'"] },

        {
          type: "match",
          q: "Match the form to the rule.",
          pairs: [
            { left: "Tom's", right: "Singular" },
            { left: "My parents'", right: "Plural" },
            { left: "Tom and Ann's", right: "Shared" }
          ],
          a: "completed"
        },

        // James: aceptar James's y James'
        { type: "mc", q: "Choose the correct form for the name James.", options: ["James's", "James", "Jame's"], a: "James's" },

        { type: "order", q: "Order the reply.", words: ["No,", "it", "is", "my", "dad's."], a: "No, it is my dad's." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTERY (Challenge)
    // ----------------------------------------------------------------------
    {
      id: "u6-set10",
      title: "Set 10: Final Challenge",
      questions: [
        { type: "mc", q: "My ___ room is messy. (brothers)", options: ["brothers'", "brother's", "brothers"], a: "brothers'" },

        { type: "input", q: "The ___ room is over there. (men)", a: "men's" },

        { type: "order", q: "Order the words.", words: ["My", "sister's", "husband's", "name", "is", "Bob."], a: "My sister's husband's name is Bob." },

        {
          type: "match",
          q: "Match the phrase to the meaning.",
          pairs: [
            { left: "Girl's", right: "One girl" },
            { left: "Girls'", right: "Many girls" },
            { left: "Children's", right: "Many children" }
          ],
          a: "completed"
        },

        // Charles: muchas veces se enseña Charles's (también existe Charles')
        { type: "mc", q: "This is ___ house. (Charles)", options: ["Charles's", "Charles", "Charle's"], a: "Charles's" },

        { type: "input", q: "We love our ___ garden. (grandparents)", a: "grandparents'" },

        { type: "order", q: "Final (order).", words: ["I", "am", "my", "mother's", "son."], a: "I am my mother's son." }
      ]
    }
  ]
};
